<script>
    import { onMount } from 'svelte';
    import { goBack, store, triggerValidation } from '../../Store.svelte';
    import { navigate } from 'svelte-routing';
    import { clientStoreSkuAvailability } from '../../clients/ClientStoreSkuAvailability.svelte';
    import PlanPanel from '../../components/movil/PlanPanel.svelte';
    import Loader from '../../components/Loader.svelte';
    import DeliveryOptions from '../../components/movil/DeliveryOptions.svelte';
    import { lineProps } from '../../data/lineProps';

    let error = '';

    onMount(async () => {
        if (!$store.requestedServices.izzimovil.length > 0) {
            navigate('/comparador', { replace: false });
            $store.settings.location = { progress: 85, step: 5 };
        } else {
            $store.settings.location = { progress: 10, step: 1.5 };
        }

        try {
            document.onreadystatechange();
        } catch (error) {}
    });

    let branchOffices = clientStoreSkuAvailability();
    let plansByTitle = Object.groupBy(
        $store.requestedServices.izzimovil,
        ({ title }) => title
    );

    const filterLinePropsBasedOnCart = (lineProps) => {
        return lineProps.filter((line) => {
            return $store.requestedServices.izzimovil.some(
                (plan) => plan.title === line.title
            );
        });
    };

    if (filterLinePropsBasedOnCart(lineProps).length > 0) {
        lineProps
            .filter((line) => line.required)
            .forEach((line) => {
                plansByTitle[line.title] = [
                    ...plansByTitle[line.title],
                    ...plansByTitle[line.required].map((plan) => {
                        return {
                            ...plan,
                        };
                    }),
                ];
                plansByTitle = Object.fromEntries(
                    Object.entries(plansByTitle).filter(
                        ([key, value]) => key !== line.required
                    )
                );
            });
    }

    const updateDeliveryTypeForAll = (newDeliveryType) => {
        $store.requestedServices.izzimovil =
            $store.requestedServices.izzimovil.map((plan) => {
                return {
                    ...plan,
                    deliveryType: newDeliveryType,
                    branch: null,
                };
            });
    };

    const updateBranchForAll = (newBranch) => {
        error = '';
        $store.requestedServices.izzimovil =
            $store.requestedServices.izzimovil.map((plan) => {
                return {
                    ...plan,
                    branch: newBranch,
                };
            });
    };

    let backHandler = () => {
        navigate('/compra/configura', { replace: false });
    };
    let nextHandler = () => {
        let plans = [];
        for (const key in plansByTitle) {
            plans.push(...plansByTitle[key]);
        }
        plans = plans.map((plan) => {
            return {
                ...plan,
                deliveryType:
                    $store.requestedServices.izzimovil[0].deliveryType,
                branch: $store.requestedServices.izzimovil[0].branch,
            };
        });
        $store.requestedServices.izzimovil = plans;
        if (
            $store.requestedServices.izzimovil[0].deliveryType === 'SUCURSAL' &&
            $store.requestedServices.izzimovil[0].branch === null
        ) {
            error = 'Por favor selecciona una sucursal para continuar';
            return;
        }
        error = '';
        navigate('/compra/datos', { replace: false });
    };

    $: {
        if ($goBack) {
            backHandler();
            goBack.set(false);
        }

        if ($triggerValidation) {
            nextHandler();
            triggerValidation.set(false);
        }
    }
</script>

<div class="pure-g justify-content-center">
    <div class="pure-u-1">
        <div class="pure-g m-b-20 justify-content-between">
            <div class="pure-u-1 pure-u-md-15-24 sm-m-b-20">
                <h3 class="text-fs-26 fw-medium">Configura tu izzi móvil</h3>
            </div>
        </div>

        {#each Object.entries(plansByTitle) as [title, plan], index}
            <PlanPanel {title} bind:plans={plan} showLines={index === 0} />
        {/each}

        <div class="d-flex align-items-center justify-content-between m-t-20">
            <a href="#/" class="back-link" on:click={backHandler}>
                <svg class="icon" aria-hidden="true"
                    ><use
                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                    ></use></svg
                >
                <span>atrás</span>
            </a>
            <button
                class="pure__button pure__button--base button-hide"
                on:click={nextHandler}>Siguiente</button
            >
        </div>
    </div>
</div>
